<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--R/O 기초정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001179') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--딜러점-->
							<th class="col-1">* {{ getMessage_('QWCC000959') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="dlrCpnyCd"
												maxlength="20"
												class="inputWithIcon"
												:readonly="roApcnPopUp.dlrCpnyReadOnlyAuth"
												@keyup.native.delete="onDelerInPutKeyDown()"
												@change="onDelerInPutKeyDown"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onDelerPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<el-input v-model="dlrCpnyNm" :placeholder="getMessage_('QWCC001068')" readonly />
							</td>

							<!--수리지역-->
							<th class="col-1">* {{ getMessage_('QWCC001050') }}</th>
							<td class="col-1">
								<el-input v-model="rprRegn" maxlength="30" :readonly="roApcnPopUp.readOnlyAuth" />
							</td>

							<!-- 발생지역 -->
							<th class="col-1">* {{ getMessage_('QWCC001049') }}</th>
							<td class="col-1">
								<el-select v-model="occuRegn" @change="changeOccuRegn" :disabled="roApcnPopUp.readOnlyAuth">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in occuRegnListPop"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>

							<!--지역세부-->
							<th class="col-1">* {{ getMessage_('QWCC001051') }}</th>
							<td class="col-1">
								<el-input v-model="dtlRegn" maxlength="30" :readonly="roApcnPopUp.readOnlyAuth" />
							</td>
						</tr>

						<tr>
							<!--원인부품-->
							<th class="col-1">* {{ getMessage_('QWCC001028') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="causPartNo"
												maxlength="20"
												class="inputWithIcon"
												@keyup.native.delete="onCausPartNoInuPutKeyDown1()"
												@change="onCausPartNoInuPutKeyDown"
												:readonly="causePartNoDisable"
											></el-input>
											<i class="icon-sf-search search-icon" @click="onCausePartPopup"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-2" colspan="2">
								<el-input v-model="causPartNm" :placeholder="getMessage_('QWCC000957')" readonly />
							</td>

							<!--정비유형-->
							<th class="col-1">* {{ getMessage_('QWCC001180') }}</th>
							<td class="col-1">
								<el-select v-model="ceqType" @change="changeCeqtype" :disabled="ceqTypeDisable">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in ceqTypeList"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>

							<!--진단일자-->
							<th class="col-1">* {{ getMessage_('QWCC001054') }}</th>
							<td class="col-1">
								<!--<el-date-picker v-model="dgnDd" type="date" :readonly="roApcnPopUp.readOnlyAuth" />-->
								<el-date-picker :value="dgnDd" @input="changeDgnDd" type="date" :readonly="roApcnPopUp.readOnlyAuth1" />
							</td>

							<!--사용기간-->
							<th class="col-1">{{ getMessage_('QWCC001053') }}</th>
							<td class="col-1">
								<el-input v-model="usePrd" maxlength="30" readonly />
							</td>
						</tr>
						<tr>
							<!--원인코드-->
							<th class="col-1">* {{ getMessage_('QWCC001029') }}</th>
							<td class="col-1">
								<!--
								<el-select v-model="causCd" @change="changeCausCd" :disabled="causeDisable">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in causCdListPop"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
								-->

								<el-col>
									<div class="search-option-wrapper__normal">
										<el-input
											v-model="causCd"
											class="inputWithIcon"
											maxlength="20"
											@keyup.native.delete="onCausCdInuPutKeyDown()"
											@change="onCausCdInuPutKeyDown"
											:readonly="causeDisable"
										></el-input>
										<i class="icon-sf-search search-icon" @click="() => onCausePopup()"></i>
									</div>
								</el-col>
							</td>

							<!--원인코드명-->
							<td class="col-2" colspan="2"><el-input v-model="causNm" :placeholder="getMessage_('QWCC001308')" readOnly /></td>

							<!--ctype-->
							<th class="col-1">* {{ getMessage_('QWCC001056') }}</th>
							<td class="col-1">
								<el-select v-model="ctype" @change="changeCtype" :disabled="cTypeDisable">
									<el-option :label="getMessage_('MWCC000342')" value=""></el-option>
									<el-option
										:key="index"
										v-for="(result, index) in ctypeList"
										:label="result.commCdName"
										:value="result.commCd"
									></el-option>
								</el-select>
							</td>

							<th class="col-1">DTC</th>
							<td class="col-1">
								<el-input v-model="dtc1" maxlength="20" :readonly="roApcnPopUp.readOnlyAuth"></el-input>
							</td>
							<td class="col-1">
								<el-input v-model="dtc2" maxlength="20" :readonly="roApcnPopUp.readOnlyAuth"></el-input>
							</td>
							<td class="col-1">
								<el-input v-model="dtc3" maxlength="20" :readonly="roApcnPopUp.readOnlyAuth"></el-input>
							</td>
						</tr>
						<tr>
							<!--현상코드-->
							<th class="col-1">* {{ getMessage_('QWCC001055') }}</th>
							<td class="col-1">
								<el-col>
									<div class="search-option-wrapper__normal">
										<el-input
											v-model="phmnCd"
											class="inputWithIcon"
											maxlength="20"
											@keyup.native.delete="onPhmnCdInuPutKeyDown()"
											@change="onPhmnCdInuPutKeyDown"
											:readonly="phmnCdDisable"
										></el-input>
										<i class="icon-sf-search search-icon" @click="() => onPhmnPopup()"></i>
									</div>
								</el-col>
							</td>
							<td class="col-1" colspan="2">
								<el-input v-model="phmnNm" :placeholder="getMessage_('QWCC001070')" readonly />
							</td>

							<!--주행거리-->
							<th class="col-1">* {{ getMessage_('QWCC000972') }}</th>
							<td class="col-1">
								<el-input v-model="milg" maxlength="7" :readonly="roApcnPopUp.readOnlyAuth" />
							</td>

							<!--정비시작일-->
							<th class="col-1">* {{ getMessage_('QWCC001183') }}</th>
							<td>
								<el-date-picker :value="ceqStrtDd" @input="changeCeqStrtDd" type="date" :readonly="roApcnPopUp.readOnlyAuth1" />
							</td>
							<!--정비완료일-->
							<th class="col-1">* {{ getMessage_('QWCC001184') }}</th>
							<td>
								<el-date-picker :value="ceqEndDd" @input="changeCeqEndDd" type="date" :readonly="roApcnPopUp.readOnlyAuth1" />
							</td>
						</tr>

						<tr>
							<!--자재비-->
							<th class="col-1">{{ getMessage_('QWCC001101') }}</th>
							<td>
								<el-input v-model="mtrlCst" maxlength="10" readonly></el-input>
							</td>
							<!--공임비-->
							<th class="col-1">{{ getMessage_('QWCC001102') }}</th>
							<td>
								<el-input v-model="wags" maxlength="10" readonly></el-input>
							</td>
							<!--부대비-->
							<th class="col-1"> {{ getMessage_('QWCC001103') }}</th>
							<td>
								<el-input :value="incdCst" readonly @input="val => changeinput(val)"></el-input>
							</td>

							<!--총금액-->
							<th class="col-1"> {{ getMessage_('QWCC002137') }}</th>
							<td class="col-1">
								<el-input v-model="dlrCpnyFee" readonly></el-input>
							</td>

							<th class="col-1" />
							<td class="col-1" />
						</tr>

						<tr>
							<th class="col-1"> {{ getMessage_('QWCC002138') }}</th>
							<td>
								<el-input :value="nonWarrantyFee" readonly @input="val => changeinput(val)"></el-input>
							</td>
							<th class="col-1"> {{ getMessage_('QWCC002139') }}</th>
							<td>
								<el-input :value="warrantyFee" readonly @input="val => changeinput(val)"></el-input>
							</td>
							<th class="col-1"> {{ getMessage_('QWCC001104') }}</th>
							<td>
								<el-input :value="totPartCst" readonly @input="val => changeinput(val)"></el-input>
							</td>
						</tr>

						<tr>
							<!--특이사항-->
							<th class="col-1">{{ getMessage_('QWCC000053') }}</th>
							<td colspan="9">
								<el-input v-model="prtlSbc" maxlength="330" :readonly="roApcnPopUp.readOnlyAuth"></el-input>
							</td>
						</tr>
						<tr>
							<!--첨부파일-->
							<th class="col-1">* {{ getMessage_('QWCC000925') }}</th>
							<td colspan="9">
								<file-upload-list
									ref="fileUploadComp"
									id="fileList"
									:propFileList="resultFileList_"
									@MultiFile="multiFile"
									:isEditable="isFiledDisabled"
									maxQuantity="10"
									width="100%"
									height="100px"
									@onDownload="onDownloadFile"
								></file-upload-list>
							</td>
						</tr>
					</tbody>
					<!--  -->
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
import qmsUtils from '@/store/qms/api';

export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam1: { type: Object },
		sendParam2: { type: Object },
		sendParam3: { type: Object },
		sendParam6: { type: Object } //원인코드추가
	},
	components: {
		FileUploadList
	},
	data() {
		return {
			ceqType: '', //정비유형
			dlrCpnyCd: '', //딜러점코드
			dlrCpnyNm: '', //딜러점명
			rprRegn: '', //수리지역
			occuRegn: '', //발생지역
			dtlRegn: '', //지역세부
			causPartNo: '', //원인부품
			causPartNm: '', //원인부품명
			usePrd: '', //사용기간
			milg: '', //주행거리
			dgnDd: '', //진단일자
			causCd: '', //원인코드
			causNm: '', //원인코드명
			phmnCd: '', //현상코드
			phmnNm: '', //현상코드명
			ctype: '', //ctypeCd
			ctype1: '', //ctype1
			dtc1: '', //dtc1
			dtc2: '', //dtc2
			dtc3: '', //dtc3
			prtlSbc: '', //특이사항

			roFileId: '', //RO전용 파일ID
			ceqStrtDd: '', //정비시작일
			ceqEndDd: '', //정비종료일
			mtrlCst: '', //자재비
			wags: '', //공임비
			incdCst: '', //부대비
			totPartCst: '', //총금액
			dlrCpnyFee: '',
			warrantyFee: '',
			nonWarrantyFee: '',

			pwaFileId: '', //pwaFileId
			//납품업체 검색 저장하는 객체
			delCmpn: {
				cpnyCd: '',
				cpnyNm: '',
				cpnyScn: '90'
			},
			commCd: {
				commCdType: 'PHMN_CD',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			},
			commCd1: {
				//원인코드팝업
				commCdType: 'CAUS_CD',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			},
			partNoInput: '',
			selPartNo: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		},
		isFiledDisabled() {
			return this.roApcnPopUp.readOnlyAuth1 ? false : true;
		},
		ceqTypeDisable() {
			//정비유형
			//캠페인번호가 들어오거나 결재가 끝나면 disable처리함.
			let campaignNo = convertNvl(this.currentCmpnNm, '');

			let selPwaNo = convertNvl(this.roApcnPopUp.pwaNo, '');

			//console.log('selPwaNo>>>>>>>>>>>>>>', selPwaNo);

			if (this.roApcnPopUp.readOnlyAuth1 == true || campaignNo != '' || selPwaNo != '') {
				return true;
			} else {
				return false;
			}
		},
		cTypeDisable() {
			//ctype
			//캠페인번호가 들어오거나 결재가 끝나면 disable처리함.
			let campaignNo = convertNvl(this.currentCmpnNm, '');

			let ceqType = convertNvl(this.ceqType, '');

			if (this.roApcnPopUp.readOnlyAuth == true || campaignNo != '' || ceqType == '20') {
				return true;
			} else {
				return false;
			}
		},
		causeDisable() {
			//원인부품번호 disableroApcnPopUp.readOnlyAuth
			//캠페인번호가 들어오거나 결재가 끝나면 disable처리함.
			let campaignNo = convertNvl(this.currentCmpnNm, '');

			if (this.roApcnPopUp.readOnlyAuth == true || campaignNo != '') {
				return true;
			} else {
				return false;
			}
		},
		causePartNoDisable() {
			//원인부품번호 disable
			//캠페인번호가 들어오거나 결재가 끝나면 disable처리함.
			let campaignNo = convertNvl(this.currentCmpnNm, '');

			if (this.roApcnPopUp.readOnlyAuth == true || campaignNo != '') {
				return true;
			} else {
				return false;
			}
		},
		phmnCdDisable() {
			//원인부품번호 disable
			//캠페인번호가 들어오거나 결재가 끝나면 disable처리함.
			let campaignNo = convertNvl(this.currentCmpnNm, '');

			if (this.roApcnPopUp.readOnlyAuth == true || campaignNo != '') {
				return true;
			} else {
				return false;
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		changeinput(val) {
			val = val.replace(/[^-\.0-9]/g, '');
			const arr = val.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (val.length > 16) {
					val = val.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				val = arr.reduce((a, b) => a + b);
			}

			this.incdCst = val;
		},
		// isShowOption(value){
		// 	console.log('----------',value);
		// 	console.log(this);
		// 	if(value === 'P' && !!this.roApcnPopUp.oemSaleDd){
		// 		return false;
		// 	}else{
		// 		return true;
		// 	}
		// },
		async changeCeqStrtDd(value) {
			//console.log('여긴가 캠페인번호??~', this.currentCmpnCd);
			//console.log('여긴가 종료일자??~', this.currentCmpnEndDt);

			if (!!value) {
				/*
				if (this.$moment(value).isAfter(this.$moment()) == true) {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001974') //정비시작일은 오늘날짜 이후일자를 선택할수가 없습니다.' ///'정비시작일은 정비완료일 이전 일자로 선택해야됩니다.' // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
					});

					this.ceqEndDd = '';
					return false;
				}
				*/
			// const erpSaleDd = convertNvl(this.saveRoApcn.erpSaleDd,null); 
			
				// const ssClassValue = await qmsUtils.getVariableValue(this.user.deptCd, this.$moment(value).format('YYYYMMDD'));
				const ssClassValue = await qmsUtils.getVariableValue(!!this.dlrCpnyCd ? this.dlrCpnyCd : this.user.deptCd, this.$moment(value).format('YYYYMMDD'));
				// console.log('this-----', this);
				let ssClass = ssClassValue ? ssClassValue.varVal : '';
				//작업내용 기준금액 가져오기(변수관리에 등록되어있음)
				const rsltVarValue = await qmsUtils.getVariableValue('pwaEndPartStdCst'+ssClass, this.$moment(value).format('YYYYMMDD'));
				// this.stdCst = rsltVarValue.varVal;
				this.$emit('ChangeStdCst', rsltVarValue.varVal);

                //  const jvSaleDd = convertNvl(this.saveRoApcn.jvSaleDd,null); 
				const oemSaleDd = convertNvl(this.saveRoApcn.oemSaleDd,null); 
				//고객사 판매일

				if(oemSaleDd!=null ){				if (!!this.roApcnPopUp.oemSaleDd) {
					if (this.$moment(value).isAfter(this.$moment(this.roApcnPopUp.oemSaleDd)) === false) {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001830') //'정비시작일은 고객사 판매일보다 이후 일자로 선택해야됩니다.'
						});
						return false;
					} else {
						if (!!this.ceqEndDd) {
							if (this.$moment(value).isSame(this.$moment(this.ceqEndDd))) {
								this.ceqStrtDd = value;
							} else if (this.$moment(value).isAfter(this.$moment(this.ceqEndDd)) !== false) {
								this.$sf_toast({
									type: 'error',
									message: this.getMessage_('QWCC001831') ///'정비시작일은 정비완료일 이전 일자로 선택해야됩니다.' // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
								});
								return false;
							} else {
								this.ceqStrtDd = value;
							}
						} else {
							this.ceqStrtDd = value;
						}
					}
						
				} else {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001832') //'고객사 판매일을 넣어주세요.'
					});
					return false;
				}
			}
				//진단일자
				if (!!this.dgnDd) {
					if (this.$moment(value).isSame(this.$moment(this.dgnDd))) {
						this.ceqStrtDd = value;
						return false;
					} else if (this.$moment(value).isAfter(this.$moment(this.dgnDd)) === false) {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001921') //'정비시작일은 진단일자보다 이후 일자로 선택해야됩니다.'
						});
						this.ceqStrtDd = '';
						return false;
					} else {
						if (!!this.ceqEndDd) {
							if (this.$moment(value).isSame(this.$moment(this.ceqEndDd))) {
								this.ceqStrtDd = value;
								return false;
							} else if (this.$moment(value).isAfter(this.$moment(this.ceqEndDd)) !== false) {
								this.$sf_toast({
									type: 'error',
									message: this.getMessage_('QWCC001831') ///'정비시작일은 정비완료일 이전 일자로 선택해야됩니다.' // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
								});
								this.ceqStrtDd = '';
								return false;
							} else {
								this.ceqStrtDd = value;
								return false;
							}
						} else {
							this.ceqStrtDd = value;
							return false;
						}
					}
				} else {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001935') //'진단일자를 넣어주세요.'
					});
					return false;
				}
			} else {
				this.ceqStrtDd = '';
			}
			

		},
		changeCeqEndDd(value) {
			if (!!value) {
				/*
				if (this.$moment(value).isAfter(this.$moment()) == true) {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001975') //정비종료일은 오늘날짜 이후일자를 선택할수가 없습니다
					});
					return false;
				}
				*/
				// const erpSaleDd = convertNvl(this.saveRoApcn.erpSaleDd,null); 


				// const jvSaleDd = convertNvl(this.saveRoApcn.jvSaleDd,null); 
				const oemSaleDd = convertNvl(this.saveRoApcn.oemSaleDd,null); 
				//고객사 판매일

				if(oemSaleDd!=null){				if (!!this.roApcnPopUp.oemSaleDd) {
					if (this.$moment(value).isAfter(this.$moment(this.roApcnPopUp.oemSaleDd)) === false) {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001833') //'정비완료일은 고객사 판매일보다 이후 일자로 선택해야됩니다.'
						});
						return false;
					} else {
						if (!!this.ceqStrtDd) {
							if (this.$moment(value).isSame(this.$moment(this.ceqStrtDd))) {
								this.ceqEndDd = value;
							} else if (this.$moment(value).isAfter(this.$moment(this.ceqStrtDd)) === false) {
								this.$sf_toast({
									type: 'error',
									message: this.getMessage_('QWCC001834') // '정비완료일은 정비시작일 이후로 선택해야됩니다.' // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
								});
								return false;
							} else {
								this.ceqEndDd = value;
							}
						} else {
							this.$sf_toast({
								type: 'error',
								message: this.getMessage_('QWCC001835') //'정비시작일을 입력해주세요.' // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
							});
							return false;
						}
					}
				} else {
					//console.log('값이 없다.');
				}}else{
					if (!!this.ceqStrtDd) {
							if (this.$moment(value).isSame(this.$moment(this.ceqStrtDd))) {
								this.ceqEndDd = value;
							} else if (this.$moment(value).isAfter(this.$moment(this.ceqStrtDd)) === false) {
								this.$sf_toast({
									type: 'error',
									message: this.getMessage_('QWCC001834') // '정비완료일은 정비시작일 이후로 선택해야됩니다.' // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
								});
								return false;
							} else {
								this.ceqEndDd = value;
							}
						} else {
							this.$sf_toast({
								type: 'error',
								message: this.getMessage_('QWCC001835') //'정비시작일을 입력해주세요.' // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
							});
							return false;
						}
				}
			} else {
				this.ceqEndDd = '';
			}
		},

		onDelerInPutKeyDown() {
			this.dlrCpnyNm = '';
			this.dlrCpnyCd = '';
			this.rprRegn = '';
		},
		onCausPartNoInuPutKeyDown1() {
			if (this.roApcnPopUp.readOnlyAuth == false) {
				this.causPartNo = '';
				this.causPartNm = '';
				const selCausPartNo = this.selPartNo;
				this.$emit('DelGridPartNo', selCausPartNo); //교환부품에 등록된 END품번을 지운다.
			}
		},
		onCausPartNoInuPutKeyDown() {
			if (this.roApcnPopUp.readOnlyAuth == false) {
				this.causPartNo = '';
				this.causPartNm = '';
			}
		},
		onCausCdInuPutKeyDown() {
			if (this.roApcnPopUp.readOnlyAuth == false) {
				this.causCd = '';
				this.causNm = '';
			} //end edit인상태
		},
		onPhmnCdInuPutKeyDown() {
			this.phmnCd = ''; //현상코드
			this.phmnNm = ''; //현상코드명
		},
		onCausePartPopup() {
			//console.log('값은>>>>>>>>', this.partNoInput);

			let ceqStrtDd = convertNvl(this.ceqStrtDd, '');
			if (ceqStrtDd == '') {
				this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001835') 
					});
				return false;
			}

			// const ssClassValue = await qmsUtils.getVariableValue(this.user.deptCd);
			// let ssClass = ssClassValue ? ssClassValue.varVal : '';

			// //작업내용 기준금액 가져오기(변수관리에 등록되어있음)
			// const rsltVarValue = await qmsUtils.getVariableValue('pwaEndPartStdCst'+ssClass);

			if (this.roApcnPopUp.readOnlyAuth == false) {
				//원인부품명
				//this.partNoInput = this.causPartNo;

				let campaignNo = convertNvl(this.currentCmpnNm, '');

				//캠페인번호가 있으면 원인부품을 못넣기 때문에 팝업을 뛰우지 말아야한다.
				if (campaignNo != '') {
					return false;
				}

				/*작업내용에 원인부품 기등록 체크해서 있으면 팝업을 안뛰움*/
				const filtered = _.filter(this.roApcnSwapPartsList, { causYn: 'Y' });

				if (filtered.length > 0) {
					//원하는 로직 실행}

					this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001887') //'작업내용에 이미 원인부품내용이 등록되어 있습니다. 수정하려면 원인부품을 지우고 다시 등록해주세요.'
					});
					return false;
				}

				let causePartInfo = {
					partNoInput: this.causPartNo,
					cmpnNoInfo: false
				};
				if (!this.currentCmpnCd) {
					//캠페인 선택하지 않을경우
					this.$emit('OpenPopupPartNo', causePartInfo); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
				} else {
					//캠페인 선택할 경우
					causePartInfo.cmpnNoInfo = true;

					this.$emit('OpenPopupPartNo', causePartInfo); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
				}
			}
		},
		onPhmnPopup() {
			//console.log('값은>>>>>>>>', this.commCd);

			if (this.roApcnPopUp.readOnlyAuth == false) {
				let campaignNo = convertNvl(this.currentCmpnNm, '');

				//캠페인번호가 있으면 현상코드를 못넣기 때문에 팝업을 뛰우지 말아야한다.
				if (campaignNo != '') {
					return false;
				}

				this.commCd.commCdType = 'PHMN_CD';
				this.commCd.commCd = this.phmnCd;

				/*현상팝업*/
				this.$emit('OpenPopupCommCode', this.commCd);
			}
		},
		onCausePopup() {
			//원인코드팝업추가
			//console.log('값은>>>>>>>>', this.commCd);

			if (this.roApcnPopUp.readOnlyAuth == false) {
				this.commCd1.commCdType = 'CAUS_CD';
				this.commCd1.commCd = this.causCd;
				this.commCd1.title = this.getMessage_('QWCC001029'); //현상코드

				/*현상팝업*/
				this.$emit('OpenCauseCdPopupCommCode', this.commCd1);
			}
		},
		onDelerPopup() {
			/*딜러팝업*/

			//console.log('값은뭐냐', this.delCmpn);

			if (this.roApcnPopUp.dlrCpnyReadOnlyAuth == false) {
				this.delCmpn.cpnyCd = this.dlrCpnyCd; //딜러점 팝없값

				this.$emit('OpenDelPopup', this.delCmpn);
			}
		},
		changeOccuRegn(value) {
			//발생지역
			this.occuRegn = value;
		},
		changeCausCd(value) {
			//원인코드
			this.causCd = value;
		},
		changeCeqtype(value) {
			//정비유형코드
			this.ceqType = value;
			if(value == '20'){
				this.ctype = '';
			}

		},
		changeCtype(value) {
			//Ctype
			this.ctype = value;
		},
		changeCmpn() {
			//console.log('this.currentCausPartNo이거 없니?', this.selectedCmpnMstList);
			this.causPartNo = this.currentCausPartNo; //원인부품
			this.causPartNm = this.currentCausPartNm; //원인부품명
			this.causCd = this.currentCausCd; //원인코드
			this.causNm = this.currentCausNm; //원인코드명
			this.phmnCd = this.currentPhmnCd; //현상코드
			this.phmnNm = this.currentPhmnNm; //현상코드명

			this.mtrlCst = this.currentMtrlCst; //자재비
			this.wags = this.currentWags; //공임비
			this.incdCst = this.currentIncdCst; //부대비
			this.totPartCst = this.currentAmt; //총금액

			this.ctype1 = 'C';
			this.ceqType = '10';
		},
		resetCtype1() {
			this.ctype1 = '';
		},
		deleteCmpn() {
			this.ctype = '';
			this.ceqType = '';
			this.causPartNo = ''; //원인부품
			this.causPartNm = ''; //원인부품명
			this.causCd = ''; //원인코드
			this.causNm = ''; //원인코드명
			this.phmnCd = ''; //현상코드
			this.phmnNm = ''; //현상코드명
			this.mtrlCst = ''; //자재비
			this.wags = ''; //공임비
			this.incdCst = ''; //부대비
			this.totPartCst = ''; //총금액
		},
		causePartInfoBeforeDataSet(value) {
			this.causPartNo = '';
			this.causPartNm = '';
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		multiFile(files, delFiles) {
			//console.log('부모창', files, delFiles);
			this.setState_({ key: 'fileList', value: files });

			//console.log('전달확인', this.fileList);
		},
		setProcessInfo() {
			//스토어에서 값을 가져와서 셋팅한다.
			if (!this.roApcnPopUp.ceqType) {
				this.ceqType = '';
			} else {
				this.ceqType = this.roApcnPopUp.ceqType; //정비유형
			}
			this.dlrCpnyCd = this.roApcnPopUp.dlrCpnyCd; //딜러점코드
			this.dlrCpnyNm = this.roApcnPopUp.dlrCpnyNm; //딜러점명
			this.rprRegn = this.roApcnPopUp.rprRegn; //수리지역
			this.occuRegn = this.roApcnPopUp.occuRegn; //발생지역
			this.dtlRegn = this.roApcnPopUp.dtlRegn; //지역세부
			this.causPartNo = this.roApcnPopUp.causPartNo; //원인부품
			this.causPartNm = this.roApcnPopUp.causPartNm; //원인부품명
			this.usePrd = this.roApcnPopUp.usePrd; //사용기간
			this.milg = this.roApcnPopUp.milg; //주행거리
			this.dgnDd = this.roApcnPopUp.dgnDd; //진단일자
			this.causCd = this.roApcnPopUp.causCd; //원인코드
			this.causNm = this.roApcnPopUp.causNm; //원인코드명
			this.phmnCd = this.roApcnPopUp.phmnCd; //현상코드
			this.phmnNm = this.roApcnPopUp.phmnNm; //현상코드명
			this.ctype = this.roApcnPopUp.ctype; //ctypeCd
			this.dtc1 = this.roApcnPopUp.dtc1; //dtc1
			this.dtc2 = this.roApcnPopUp.dtc2; //dtc2
			this.dtc3 = this.roApcnPopUp.dtc3; //dtc3
			this.prtlSbc = this.roApcnPopUp.prtlSbc; //특이사항
			this.pwaFileId = this.roApcnPopUp.pwaFileId; //PWA에서 오는 파일ID
			this.roFileId = this.roApcnPopUp.roFileId; //ro전용 파일ID

			//this.ceqStrtDd = this.roApcnPopUp.ceqStrtDd; //정비시작일
			//this.ceqEndDd = this.roApcnPopUp.ceqEndDd; //정비종료일
			this.mtrlCst = this.roApcnPopUp.mtrlCst; //자재비
			this.wags = this.roApcnPopUp.wags; //공임비
			this.incdCst = this.roApcnPopUp.incdCst; //부대비
			this.totPartCst = this.roApcnPopUp.totPartCst; //총금액
			this.dlrCpnyFee =  this.roApcnPopUp.dlrCpnyFee;
			this.warrantyFee =  this.roApcnPopUp.warrantyFee;
			this.nonWarrantyFee =  this.roApcnPopUp.nonWarrantyFee;
			//받아온 파일 리스트조회
			this.$refs.fileUploadComp.reloadFileList(this.fileList);
		},
		delInputComp() {
			this.causPartNo = ''; //원인부품
			this.causPartNm = ''; //원인부품명
			//this.dgnDd = ''; //진단일자
			this.usePrd = ''; //사용기간
			this.dlrCpnyCd = ''; //딜러점코드
			this.dlrCpnyNm = ''; //딜러점명
			this.rprRegn = ''; //수리지역
			this.milg = ''; //주행거리
			this.ctype = ''; //Ctype
			this.causCd = ''; //원인코드
			this.causNm = ''; //원인코드명
			this.phmnCd = ''; //현상코드
			this.phmnNm = ''; //현상코드명
			this.dtc1 = ''; //dtc1
			this.dtc2 = ''; //dtc2
			this.dtc3 = ''; //dtc3
			this.prtlSbc = ''; //특이사항
			this.occuRegn = ''; //발생지역
			this.dtlRegn = ''; //지역세부
			this.pwaFileId = ''; //pwaFileId
			this.roFileId = '';
			this.mtrlCst = ''; //자재비
			this.totPartCst = ''; //총금액 삭제
			this.ceqType = ''; //정비유형

			this.mtrlCst = ''; //자재비
			this.wags = ''; //공임비
			this.incdCst = ''; //부대비
			this.totPartCst = ''; //총금액

			//첨부된 파일리스트 삭제
			this.setState_({ key: 'fileList', value: [] });
			this.$refs.fileUploadComp.delInitFileList();
		},
		delCeqDt() {
			this.ceqStrtDd = ''; //정비시작일
			this.ceqEndDd = ''; //정비완료일
			this.usePrd = ''; //사용기간
		},
		setCeqInfoProcessInfo(args) {
			this.ceqType = args;
		},
		async changeDgnDd(value) {
			if (value !== null) {
				let tmpTo = this.$moment().format('YYYY-MM-DD');

				let tmpFrom = this.$moment(this.roApcnPopUp.erpSaleDd).format('YYYY-MM-DD');
				// console.log('tmpFrom-------', tmpFrom);
				// const erpSaleDd = convertNvl(this.saveRoApcn.erpSaleDd,null); 

				// const jvSaleDd = convertNvl(this.saveRoApcn.jvSaleDd,null);
				const oemSaleDd = convertNvl(this.saveRoApcn.oemSaleDd,null); 

				if(oemSaleDd!=null){				if (this.roApcnPopUp.oemSaleDd !== '') {
					if (this.$moment(this.$moment(value).format('YYYY-MM-DD')).isSame(this.$moment().format('YYYY-MM-DD')) === true) {
						//입력날자와 오늘날짜가 같은경우
						this.dgnDd = value;

						//console.log('>>>>>111', this.dgnDd);

						let paramList = {
							oemSaleD: this.$moment(this.roApcnPopUp.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
							dgnDd: this.$moment(this.dgnDd).format('YYYYMMDD')
						};

						//사용기간(년)
						await this.getRoUsedYear_(paramList);
					} else if (this.$moment(value).isBetween(tmpFrom, tmpTo) === true) {
						//입력날자가 고객사 판매일과 오늘날짜안에 있으면 값을 넣는다.
						this.dgnDd = value;

						//console.log('>>>>>222', this.dgnDd);

						let paramList = {
							oemSaleD: this.$moment(this.roApcnPopUp.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
							dgnDd: this.$moment(this.dgnDd).format('YYYYMMDD') //진단일자
						};

						//사용기간(년)
						await this.getRoUsedYear_(paramList);
					} else {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001693') // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
						});
					}
				} else {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_('QWCC001694') //'고객사 판매일을 선택해주세요.' //
					});

					this.dgnDd = value;
				}}else{
				if (this.$moment(this.$moment(value).format('YYYY-MM-DD')).isSame(this.$moment().format('YYYY-MM-DD')) === true 
						|| this.$moment(value).isBetween(tmpFrom, tmpTo) === true) {
						//입력날자와 오늘날짜가 같은경우
						this.dgnDd = value;

						//console.log('>>>>>111', this.dgnDd);

						let paramList = {
							oemSaleD: this.$moment(this.roApcnPopUp.oemSaleDd).format('YYYYMMDD'), //OEM판매일자.
							dgnDd: this.$moment(this.dgnDd).format('YYYYMMDD')
						};

						//사용기간(년)
						await this.getRoUsedYear_(paramList);
					} else {
						this.$sf_toast({
							type: 'error',
							message: this.getMessage_('QWCC001693') // '진단일자는 고객사 판매일 이전 일자를 선택할수가 없습니다.' //
						});
					}}
			} else {
				this.dgnDd = '';
			}
		},
		setUsedYearProcessInfo() {
			this.usePrd = this.roApcnPopUp.selUsedYear; //사용기간
		}

		/*,
		chkUsedPrd() {
			const ceqType = convertNvl(this.saveRoApcn.ceqType, '');

			if (ceqType == 10) {
			}
		},
		chkMilg() {
			const ceqType = convertNvl(this.saveRoApcn.ceqType, '');

			if (ceqType == 10) {
			}
		}
		*/
	},
	async created() {
		try {
			//let place1 = this.$sf_formatString(this.getMessage_('QWCC001064'), [this.getMessage_('QWCC000959')]);

			this.$sf_toggleLoading(true);

			await this.getCommCodes_({ key: 'ceqTypeList', codeType: 'CEQ_TYPE' }) //정비유형
				.then(() => this.getCommCodes_({ key: 'ctypeList', codeType: 'CTYPE' })) //CTYPE
				.then(() => this.getCommCodes_({ key: 'causCdListPop', codeType: 'CAUS_CD' })) //원인코드
				.then(() => this.getCommCodes_({ key: 'occuRegnListPop', codeType: 'OCCU_REGN' })); //

			//스토어에서 값을 가져와서 셋팅한다.


			if(this.roApcnPopUp.readOnlyAuth){
				this.roApcnPopUp.dlrCpnyReadOnlyAuth = this.roApcnPopUp.readOnlyAuth;
			}
			
			this.ceqType = this.roApcnPopUp.ceqType; //정비유형
			if(this.roApcnPopUp.dlrCpnyCd){
				this.dlrCpnyCd = this.roApcnPopUp.dlrCpnyCd; //딜러점코드
				this.dlrCpnyNm = this.roApcnPopUp.dlrCpnyNm; //딜러점명
			}else if(this.isMqyStation){
				let result = await qmsUtils.getDeptNm(this.user.deptCd);
				this.dlrCpnyCd = result.deptCd; //딜러점코드
				this.dlrCpnyNm = result.deptNm; //딜러점명
				this.roApcnPopUp.dlrCpnyReadOnlyAuth = true;
			}
			

			this.rprRegn = this.roApcnPopUp.rprRegn; //수리지역
			this.occuRegn = this.roApcnPopUp.occuRegn; //발생지역

			this.dtlRegn = this.roApcnPopUp.dtlRegn; //지역세부
			this.causPartNo = this.roApcnPopUp.causPartNo; //원인부품
			this.causPartNm = this.roApcnPopUp.causPartNm; //원인부품명
			this.selPartNo = this.roApcnPopUp.causPartNo; //원인부품에서 삭제시 필요함

			this.usePrd = this.roApcnPopUp.usePrd; //사용기간
			// this.milg = this.roApcnPopUp.milg; //주행거리
			this.milg = convertNvl(this.roApcnPopUp.milg, '') == '' ? 0 : this.roApcnPopUp.milg; //진단일자

			this.dgnDd = convertNvl(this.roApcnPopUp.dgnDd, '') == '' ? this.$moment().format('YYYY-MM-DD') : this.roApcnPopUp.dgnDd; //진단일자
			this.causCd = this.roApcnPopUp.causCd; //원인코드
			this.causNm = this.roApcnPopUp.causNm; //원인코드명

			this.phmnCd = this.roApcnPopUp.phmnCd; //현상코드
			this.phmnNm = this.roApcnPopUp.phmnNm; //현상코드명

			this.ctype = this.roApcnPopUp.ctype; //ctypeCd
			this.dtc1 = this.roApcnPopUp.dtc1; //dtc1

			this.dtc2 = this.roApcnPopUp.dtc2; //dtc2
			this.dtc3 = this.roApcnPopUp.dtc3; //dtc3
			this.prtlSbc = this.roApcnPopUp.prtlSbc; //특이사항
			this.pwaFileId = this.roApcnPopUp.pwaFileId; //pwa파일Id
			this.roFileId = this.roApcnPopUp.roFileId; //ro전용 파일ID

			this.ceqStrtDd = this.roApcnPopUp.ceqStrtDd; //정비시작일
			this.ceqEndDd = this.roApcnPopUp.ceqEndDd; //정비종료일
			this.mtrlCst = this.roApcnPopUp.mtrlCst; //자재비
			this.wags = this.roApcnPopUp.wags; //공임비
			this.incdCst = this.roApcnPopUp.incdCst; //부대비
			this.totPartCst = this.roApcnPopUp.totPartCst; //총금액

			this.dlrCpnyFee = this.roApcnPopUp.dlrCpnyFee;
			this.warrantyFee = this.roApcnPopUp.warrantyFee;
			this.nonWarrantyFee = this.roApcnPopUp.nonWarrantyFee;
		
			this.$sf_toggleLoading(false);
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	},
	watch: {
		sendParam1(newValue, oldValue) {
			//딜러점
			this.dlrCpnyCd = this.sendParam1.cpnyCd;
			this.dlrCpnyNm = this.sendParam1.cpnyNm;
			//수리지역
			this.rprRegn = this.sendParam1.regn;

			this.delCmpn.cpnyCd = this.dlrCpnyCd;
			this.delCmpn.cpnyNm = this.dlrCpnyNm;
		},
		sendParam2(newValue, oldValue) {
			//현상코드
			this.phmnCd = this.sendParam2.commCd;
			this.phmnNm = this.sendParam2.commCdName;

			this.commCd.commCdType = this.sendParam2.commCdType;
			this.commCd.commCd = this.sendParam2.commCd;
		},
		sendParam3(newValue, oldValue) {
			//원인부품
			this.causPartNo = this.sendParam3.partNo;
			this.causPartNm = this.sendParam3.partNm;
			this.selPartNo = this.sendParam3.partNo;
		},
		sendParam6(newValue, oldValue) {
			//원인코드추가
			//원인코드명
			this.causCd = this.sendParam6.commCd;
			this.causNm = this.sendParam6.commCdName;

			this.commCd1.commCdType = this.sendParam6.commCdType;
			this.commCd1.commCd = this.sendParam6.commCd;
		},
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateApcnSave_({ key: 'ceqType', value: convertNvl(this.ceqType, '') }); //정비유형
				this.setStateApcnSave_({ key: 'dlrCpnyCd', value: convertNvl(this.dlrCpnyCd, '') }); //딜러점코드
				this.setStateApcnSave_({ key: 'dlrCpnyNm', value: convertNvl(this.dlrCpnyNm, '') }); //딜러점명
				this.setStateApcnSave_({ key: 'rprRegn', value: convertNvl(this.rprRegn, '') }); //수리지역
				this.setStateApcnSave_({ key: 'occuRegn', value: convertNvl(this.occuRegn, '') }); //발생지역
				this.setStateApcnSave_({ key: 'dtlRegn', value: convertNvl(this.dtlRegn, '') }); //지역세부
				this.setStateApcnSave_({ key: 'causPartNo', value: convertNvl(this.causPartNo, '') }); //원인부품
				this.setStateApcnSave_({ key: 'causPartNm', value: convertNvl(this.causPartNm, '') }); //원인부품명
				this.setStateApcnSave_({ key: 'usePrd', value: convertNvl(this.usePrd, '') }); //사용기간
				this.setStateApcnSave_({ key: 'milg', value: convertNvl(this.milg, '') }); //주행거리
				this.setStateApcnSave_({
					key: 'dgnDd',
					value: convertNvl(this.dgnDd, '') == '' ? '' : this.$moment(this.dgnDd).format('YYYYMMDD')
				}); //진단일자
				this.setStateApcnSave_({ key: 'causCd', value: convertNvl(this.causCd, '') }); //원인코드
				this.setStateApcnSave_({ key: 'phmnCd', value: convertNvl(this.phmnCd, '') }); //현상코드
				this.setStateApcnSave_({ key: 'phmnNm', value: convertNvl(this.phmnNm, '') }); //현상코드명
				this.setStateApcnSave_({ key: 'ctype', value: convertNvl(this.ctype, '') }); //ctypeCd
				this.setStateApcnSave_({ key: 'dtc1', value: convertNvl(this.dtc1, '') }); //dtc1
				this.setStateApcnSave_({ key: 'dtc2', value: convertNvl(this.dtc2, '') }); //dtc2
				this.setStateApcnSave_({ key: 'dtc3', value: convertNvl(this.dtc3, '') }); //dtc3
				this.setStateApcnSave_({ key: 'prtlSbc', value: convertNvl(this.prtlSbc, '') }); //특이사항
				this.setStateApcnSave_({ key: 'fileList', value: this.fileList }); //파일리스트
				this.setStateApcnSave_({ key: 'roFileId', value: this.roFileId }); //RO파일Id
				this.setStateApcnSave_({ key: 'pwaFileId', value: this.pwaFileId }); //PWA파일Id

				this.setStateApcnSave_({
					key: 'ceqStrtDd',
					value: convertNvl(this.ceqStrtDd, '') == '' ? '' : this.$moment(this.ceqStrtDd).format('YYYYMMDD')
				}); //정비시작일
				this.setStateApcnSave_({
					key: 'ceqEndDd',
					value: convertNvl(this.ceqEndDd, '') == '' ? '' : this.$moment(this.ceqEndDd).format('YYYYMMDD')
				}); //정비 종료일
				this.setStateApcnSave_({ key: 'mtrlCst', value: this.mtrlCst }); //자재비
				this.setStateApcnSave_({ key: 'wags', value: this.wags }); //공임비
				this.setStateApcnSave_({ key: 'incdCst', value: this.incdCst }); //부대비
			}
		},
		//삭제Flag
		isDelPwaCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelPwaCompInitFlag) {
				this.delInputComp();
			}
		},

		isDelCamPaignCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelCamPaignCompInitFlag) {
				this.delInputComp();
			}
		},
		isDelCeqDtCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelCeqDtCompInitFlag) {
				this.delCeqDt();
			}
		},
		ctype1() {
			this.ctype = this.ctype1;
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -1px;
}
.custom_td_col1 {
	width: 10px;
}
.custom_td_col2 {
	width: 170px;
}
</style>
